import React, { useState } from "react";
import SearchInput from "./components/SearchInput.jsx";
import LightningOutHost from "./components/LightningOutHost.jsx";

/**
 * /service — Client Credentials flow POC.
 *
 * No end-user login. The backend mints a Salesforce session via OAuth 2.0
 * Client Credentials, then exchanges it for a frontdoor URL. The LWC iframe
 * runs as the Connected App's configured "Run As" user.
 *
 * This is the pattern we will hand to the AEM team: AEM's server performs
 * the same two-step token → frontdoor exchange; no user auth on the host page.
 */
export default function ServiceView() {
    const [keyword, setKeyword] = useState("");
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [mode, setMode] = useState("list");

    const handleRecordSelect = (rec) => {
        setSelectedRecord(rec);
        setMode("detail");
    };
    const handleHostNavigate = () => {
        setSelectedRecord(null);
        setMode("list");
    };

    return (
        <div className="app">
            <div className="panel">
                <div
                    className="row"
                    style={{ justifyContent: "space-between" }}
                >
                    <div>
                        <h1>⚡ Service Account Mode — no user login</h1>
                        <p className="tagline">
                            This page uses <strong>OAuth 2.0 JWT Bearer</strong>{" "}
                            flow. The backend signs an RS256 JWT (no user
                            password), exchanges it for an access token that
                            impersonates the configured integration user, and
                            mints a frontdoor URL. All LWC requests run as that
                            user.
                        </p>
                    </div>
                    <a className="btn secondary" href="/">
                        ← Home (user login)
                    </a>
                </div>

                {mode === "list" && (
                    <SearchInput value={keyword} onChange={setKeyword} />
                )}

                <div className="meta">
                    Endpoint: <code>/api/service-frontdoor-url</code> · Flow:{" "}
                    <code>
                        grant_type=urn:ietf:params:oauth:grant-type:jwt-bearer
                    </code>{" "}
                    · No session cookie used.
                </div>
            </div>

            <div className="panel">
                <LightningOutHost
                    keyword={keyword}
                    mode={mode}
                    selectedRecord={selectedRecord}
                    onRecordSelect={handleRecordSelect}
                    onHostNavigate={handleHostNavigate}
                    frontdoorEndpoint="/api/service-frontdoor-url"
                    requireCookieWarmup={true}
                />
            </div>
        </div>
    );
}
